import { AxiosResponse } from 'axios';

import {
  Project,
  ProjectsAvailabilityByProjectKey,
} from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';
import { Utils } from '@qality/common-utils';

export const DEFAULT_VISIBILITY = true;

export default {
  async getSettings(): Promise<Array<Project>> {
    return StorageOfUniqueServices.get('SettingServiceUnique').getSettings();
  },

  async getSettingsForProject(project: { key: string }): Promise<Project> {
    return StorageOfUniqueServices.get(
      'SettingServiceUnique'
    ).getSettingsForProject(project);
  },

  async updateAppVisibilityInAllProjects(
    projects: Array<Project>,
    isAppVisibilityInAllProjects: boolean
  ): Promise<AxiosResponse> {
    return StorageOfUniqueServices.get(
      'SettingServiceUnique'
    ).updateAppVisibilityInAllProjects(projects, isAppVisibilityInAllProjects);
  },

  async updatePluginEnabledInAllProjects(
    projects: Array<Project>,
    isPluginEnabled: boolean
  ): Promise<AxiosResponse> {
    return StorageOfUniqueServices.get(
      'SettingServiceUnique'
    ).updatePluginEnabledInAllProjects(projects, isPluginEnabled);
  },

  updateQAlitySettings(projectWithSettings: Project): Promise<AxiosResponse> {
    return StorageOfUniqueServices.get(
      'SettingServiceUnique'
    ).updateQAlitySettings(projectWithSettings);
  },

  async filterProjectsByAvailability(
    projects: Array<Project>
  ): Promise<Array<Project>> {
    const settings = await StorageOfUniqueServices.get(
      'SettingServiceUnique'
    ).getProjectsAvailabilityByProjectKey(projects);
    return projects.filter(getIsProjectAvailablePredicate(settings));
  },
};

/**
 * Returns predicate for project availability
 */
export function getIsProjectAvailablePredicate(
  projectsAvailabilityByProjectKey: ProjectsAvailabilityByProjectKey
): (project: Project) => boolean {
  return (project) =>
    !Utils.isNilOrEmpty(projectsAvailabilityByProjectKey[project.key])
      ? projectsAvailabilityByProjectKey[project.key].isPluginEnabled
      : DEFAULT_VISIBILITY;
}
